import { RefObject, useEffect, useRef } from 'react';

type RectCallback = (rect: DOMRect) => void;

export default function useElementRectOnMutation(
  target: RefObject<HTMLElement>,
  callback: RectCallback,
) {
  const callbackRef = useRef<RectCallback>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const el = target.current;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      callbackRef.current(el.getBoundingClientRect());
    });

    observer.observe(el);

    callbackRef.current(el.getBoundingClientRect());

    return () => {
      observer.disconnect();
    };

    /**
     * @todo
     * 현재 Element 값을 직접 참조하지 않고, Swiper Ref 등 원본 참조 될 수 있도록 추후 리팩토링 할 때 변경하기
     */
  }, [target.current]);
}
